import Country from "@bimproject/country";
import styled from "styled-components";

import { useDialog } from "~/src/modules/ui-kit";

import { Finder2 } from "../../../../../modules/finder";
import * as UI from "../../../../../modules/ui-kit";
import CountryFinderPlugin from "../entities/country/CountryFinderPlugin";


const Styled = styled.div`
    display: grid;
    gap: 16px 32px;
    grid-template-columns: repeat(1, 256px);

    & > div {
        display: flex;
        flex-direction: row;
        gap: 8px;

        & > button {
            align-self: center;
        }
    }

    button {
        grid-column: 1 / -1;
        justify-self: start;
    }

    dialog {
        ul {
            display: flex;
            flex-direction: column;
            gap: 4px;
            margin: 0;
            padding: 0;
        }
    }
`;

export default function Countries(props) {
    const { disabled, onChange, value = [] } = props;

    const [Dialog, open, close] = useDialog();

    function onSelect(country) {
        onChange([...value, country]);
        close();
    }

    return (
        <Styled>
            {
                !value.length && (
                    <span>All countries</span>
                )
            }
            {
                value
                    .slice()
                    .sort(Country.compare)
                    .map(
                        (country) => (
                            <div key={ country }>
                                <UI.LocaleCard title={ Country.fromCode(country).name }>
                                    <UI.Flag code={ Country.fromCode(country).alpha2Code } />
                                </UI.LocaleCard>
                                <UI.Button
                                    $size="small"
                                    disabled={ disabled }
                                    onClick={ () => onChange(value.filter((e) => e !== country)) }
                                >x</UI.Button>
                            </div>
                        )
                    )
            }
            <UI.Button
                disabled={ disabled }
                onClick={ open }
            >Add country</UI.Button>
            <Dialog>
                <Finder2>
                    <CountryFinderPlugin
                        exclude={ value }
                        Component={
                            ({ code, ...restProps }) => (
                                <UI.Button { ...restProps }>
                                    <UI.LocaleCard title={ Country.fromCode(code).name }>
                                        <UI.Flag code={ Country.fromCode(code).alpha2Code } />
                                    </UI.LocaleCard>
                                </UI.Button>
                            )
                        }
                        onSelect={ onSelect }
                    />
                </Finder2>
            </Dialog>
        </Styled>
    );
}
